import styled from 'styled-components';

const FontSize18SkyblueSpan = styled.span`
  color: #71bad8;
  font-size: 18px;
  font-weight: 400;
`;

export default FontSize18SkyblueSpan;
